.textInput {
  --ixf-text-icon-height: 1rem;
  --ixf-text-icon-width: 1rem;
  --ixf-text-input-border-weight: var(--ixf-input-border-weight);

  position: relative;
  width: 100%;

  .inputElement {
    border-left: var(--ixf-text-input-border-weight) solid
      var(--ixf-input-border-color);
    border-right: var(--ixf-text-input-border-weight) solid
      var(--ixf-input-border-color);
    border-top-left-radius: 0;
    border-top-right-radius: 0;

    &:first-of-type {
      border-top: var(--ixf-input-border-weight) solid
        var(--ixf-input-border-color);
      border-top-left-radius: var(--ixf-input-border-radius);
      border-top-right-radius: var(--ixf-input-border-radius);

      > input {
        border-top-left-radius: var(--ixf-input-border-radius);
        border-top-right-radius: var(--ixf-input-border-radius);
      }
    }

    &:last-of-type {
      border-bottom: var(--ixf-text-input-border-weight) solid
        var(--ixf-input-border-color);
      border-bottom-left-radius: var(--ixf-input-border-radius);
      border-bottom-right-radius: var(--ixf-input-border-radius);

      > input {
        border-bottom-left-radius: var(--ixf-input-border-radius);
        border-bottom-right-radius: var(--ixf-input-border-radius);
      }
    }
  }

  .field {
    display: inline-flex;
    flex: 1 1 auto;
    font-size: var(--ixf-input-font-size);
    line-height: var(--ixf-input-line-height);
    font-weight: var(--ixf-input-font-weight);
    padding: var(--ixf-input-padding);
    color: var(--ixf-input-font-color);
    width: 100%;

    &.variant-monospace {
      font-family: var(--ixf-font-family-mono);
    }

    &:focus {
      outline: none;
    }

    /* &:focus-visible {
      box-shadow: 0 0 0 2px var(--ixf-text-tone-md) inset;
    } */

    &::placeholder,
    &.isEmptyMask {
      color: var(--ixf-input-placeholder-color);
    }
  }

  .affix {
    display: inline-flex;
    flex: 0 0 auto;

    svg path {
      fill: var(--ixf-input-font-color);
    }
  }

  .prefix {
    padding-left: var(--ixf-input-padding-horizontal);
    padding-right: var(--ixf-space-2);
  }

  .suffix {
    padding-right: var(--ixf-input-padding-horizontal);

    .clearButton {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:disabled {
        cursor: default;
      }
    }
  }

  &.size-small {
    --ixf-input-padding-vertical: var(--ixf-space-1);
    --ixf-input-padding-horizontal: var(--ixf-space-2);
    --ixf-input-height: 32px;
    --ixf-input-border-radius: 6px;
  }

  &.hasValue {
    .field {
      --ixf-input-padding: calc(
          var(--ixf-input-padding-vertical) +
            var(--ixf-input-label-active-offset)
        )
        var(--ixf-input-padding-horizontal)
        calc(var(--ixf-input-padding-vertical) - var(--ixf-input-label-gap))
        var(--ixf-input-padding-horizontal);
    }
  }

  input {
    &::-webkit-inner-spin-button,
    &::-webkit-inner-spin-button,
    &[type="number"] {
      -webkit-appearance: none;
      -moz-appearance: textfield;
      appearance: textfield;
      margin: 0;
    }
  }
}
